import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class YincanaService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  addYincana(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'flujo_yinkana',
        flujo:'yinkanas',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }

  getYincanas(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all_yin_by_id_usuario',
        flujo:'yinkanas',
        data: { id_usuario_yinkana: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
}
